export const getOrientation = () => {
  // prettier-ignore
  return window.screen.orientation
    ? window.screen.orientation.type.startsWith('portrait')
      ? 'portrait'
      : 'landscape'
    : window.matchMedia('(orientation: portrait)')
      ? 'portrait'
      : 'landscape'
}

/* OS types */

export const isAndroid = () => {
  return /Android/i.test(window.navigator.userAgent)
}

export const isiOS = () => {
  return (
    /iPhone|iPad|iPod/i.test(window.navigator.userAgent) ||
    (window.navigator.userAgent.includes('Macintosh') && window.navigator.maxTouchPoints >= 1)
  )
}

export const isMobileOS = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    window.navigator.userAgent
  )
}

export const getiOSVersion = () => {
  const ua = window.navigator.userAgent
  let versionArray = null
  if (/(iPhone|iPad)/i.test(ua)) {
    // iPhone and iPad (iOS 12 and below)
    versionArray = ua.match(/OS (\d+)_(\d+)_?(\d+)?/)
  } else if (
    window.navigator.userAgent.includes('Macintosh') &&
    window.navigator.maxTouchPoints >= 1
  ) {
    // iPad (iOS 13 and above)
    versionArray = navigator.userAgent.match(/Version\/(\d+)\.(\d+)\.?(\d+)?/)
  }

  const major = versionArray && versionArray[1] ? versionArray[1] : '0'
  const minor = versionArray && versionArray[2] ? versionArray[2] : '0'
  // const patch = versionArray && versionArray[3] ? versionArray[3] : '0'
  const version = Number(`${major}.${minor}`) || 0
  return version
}

/* device types */

export const isMac = () => {
  return (
    !isiOS() &&
    window.navigator.userAgent.includes('Macintosh') &&
    window.navigator.maxTouchPoints < 1
  )
}

export const isiPad = () => {
  return (
    /iPad/i.test(window.navigator.userAgent) ||
    (window.navigator.userAgent.includes('Macintosh') && window.navigator.maxTouchPoints >= 1)
  )
}

export const isiPhone = () => {
  return /iPhone/i.test(window.navigator.userAgent)
}

/* browser types */

export const getBrowserName = () => {
  const test = (regexp) => regexp.test(window.navigator.userAgent)
  switch (true) {
    case test(/edg/i):
      return 'Edge'
    case test(/trident/i):
      return 'IE'
    case test(/firefox|fxios/i):
      return 'Firefox'
    case test(/opr\//i):
      return 'Opera'
    case test(/ucbrowser/i):
      return 'UC Browser'
    case test(/samsungbrowser/i):
      return 'Samsung Browser'
    case test(/chrome|chromium|crios/i):
      return 'Chrome'
    case test(/safari/i):
      return 'Safari'
    default:
      return 'Other'
  }
}

export const isSafari = () => {
  return /safari/i.test(window.navigator.userAgent)
}

export const isChromeOrEdge = () => {
  return /chrome|chromium|crios|edg/i.test(window.navigator.userAgent)
}
